<template>
  <div id="main" class="lg:overflow-y-hidden"
       :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]"
  >
    <guide-line v-show="$store.state.windowWidth > 1024" v-model="guideLines"/>
    <the-nav/>
    <transition :name="routerTransition" mode="out-in">
      <router-view @changeRouteTitle="changeRouteTitle"
                   @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"
                   @update_nav_menu="(fn) => fn(navMenuItems)"/>
    </transition>

    <back-to-top
        bottom="5%" :right="$store.state.windowWidth < 1280 ? '0' : '5%'" offset="500"
        is-virtual-scroll
        @scrollTo="scrollTop"
        style="z-index: 50"
    >
      <vs-button style="margin: 0 16px 30px 0; border-radius: 50%; border: 1px solid #fff;" icon-pack="feather"
                 icon="icon-arrow-up"
                 class="btn-back-to-top"
                 color="#000"/>
    </back-to-top>
    <div class="fixed text-white music-controller-wrapper z-50"
         :style="musicControllerPosition">
      <div
          @click="music = (music === null ? true : !music)"
          class="wrap cursor-pointer"
      >
        <kinesis-container
            ref="audio"
            class="relative blex"
            style="width: 25px; height: 25px;"
            :audio="require('@/assets/audio/bg.mp3')">
          <v-tooltip
              :shown="$store.state.scrollY === 0 && music === null"
              :distance="1"
              placement="left"
              style="z-index: 2;"
          >
            <mdicon :color="music === null ? 'text-grey-light' : 'text-white'"
                    :name="music === null ? 'volume-low' : music ? 'volume-high' : 'volume-variant-off'"></mdicon>
            <template #popper>
              <a v-close-popper class="font-normal text-white">
                {{ $t('suggestMusic') }}
              </a>
            </template>
          </v-tooltip>
          <!--     border     -->
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="20"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="40"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="60"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="80"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="100"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
          <kinesis-audio
              type="scale"
              class="w-full h-full absolute blex z-1"
              :strength="40"
              :audioIndex="120"
          >
            <kinesis-element
                :strength="0"
                type="depth"
                :style="{borderColor: music ? 'rgba(255,255,255,0.45)' : 'transparent'}"
                style="width: 25px; height: 25px; border-width: 1px; border-style: solid; border-radius: 50%;"
            >

            </kinesis-element>
          </kinesis-audio>
        </kinesis-container>
      </div>
    </div>
  </div>
</template>


<script>
import BackToTop from '@/views/components/BackToTop'
import TheCustomizer from '@/layouts/components/customizer/TheCustomizer.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import TheNav from '../../views/components/TheNav'
import GuideLine from '../../views/components/GuideLine'
import {EventBus} from '../../EventBus'

export default {
  components: {
    BackToTop,
    TheCustomizer,
    TheFooter,
    GuideLine,
    TheNav
  },
  data () {
    return {
      music: null,
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      guideLines: [
        {
          name: 'hero',
          className: 'hero',
          label: 'MAIN'
        },
        {
          name: 'trailer', className: 'trailer', label: 'TRAILER'
        },
        {
          name: 'token', className: 'token', label: 'TOKEN'
        },
        {
          name: 'pte', className: 'pte', label: 'PLAY TO EARN'
        },
        {
          name: 'cte',
          className: 'cte',
          label: 'CLEAN TO EARN'
        },
        {
          name: 'ugc',
          className: 'ugc',
          label: 'UGC'
        },
        {
          name: 'seed-box', className: 'seed-box', label: 'SEEDBOX'
        },
        {
          name: 'voice-video', className: 'voice-video', label: 'VIDEO & VOICE CHAT'
        },
        {
          name: 'dao', className: 'dao', label: 'DAO'
        },
        {
          name: 'the-map', className: 'the-map', label: 'MAP'
        },
        {
          name: 'nft', className: 'nft', label: 'NFT COLLECTION'
        },
        {
          name: 'pfp', className: 'pfp', label: 'PFP'
        },
        {
          name: 'nft-market', className: 'nft-market', label: 'NFT MINTING PAGE'
        },
        {
          name: 'road-map', className: 'road-map', label: 'ROADMAP'
        },
        // {
        //   name: 'team', className: 'team', label: 'TEAM'
        // },
        {
          name: 'partner', className: 'partner', label: 'PARTNERS'
        },
        {
          name: 'listed', className: 'listed', label: 'LISTED'
        }
      ]
    }
  },
  watch: {
    music (val) {
      if (val) {
        this.$refs['audio'].play()
      } else {
        this.$refs['audio'].stop()
      }
    },
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    musicControllerPosition () {
      let top = 0
      if (this.$store.state.windowWidth < 1024) {
        top = 60
      } else {
        top = 90
      }
      if (this.$store.state.scrollY > 50 && this.$store.state.scrollDirection !== 'up') top /= 6
      return {
        top: `${top}px`
      }
    },
    musicSuggestSkidding () {
      let top = 0
      if (this.$store.state.windowWidth < 1024) {
        top = 30
      } else {
        top = 45
      }
      return this.$store.state.scrollY > 50 ? -top : this.$store.state.scrollY === 0 ? 0 : top
    },
    bodyOverlay () {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    layoutTypeClass () {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType () {
      return this.$store.state.mainLayoutType
    },
    navbarClasses () {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    scrollTop () {
      EventBus.$emit('scrollTo')
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
<style lang="scss">
.v-popper__wrapper {
  .v-popper__inner {
    background: #000 !important;
    color: #fff !important;
    font-weight: 700 !important;
  }

  .v-popper__arrow-container {
    .v-popper__arrow-outer {
      border-color: #000;
    }

    //.v-popper__arrow-inner {
    //  border-color: #FFD200 !important;
    //  background: #ffd200;
    //}
  }
}

.music-controller-wrapper {
  transition: all .1s linear;
  right: 12px;
}
</style>
